export const isArabic = (name: string)=>{
    
    if (name.charCodeAt(0) > 122){
        return true
    }
    return false 
}